/* Hydrate the native search only when its native trigger or Meta+k is used. */
(() => {
  const template = document.getElementById('nc-search-template');
  if (!(template instanceof HTMLTemplateElement)) return;
  let loading;
  let wantsOpen = false;

  const load = () => {
    if (loading) return loading;
    loading = (async () => {
      const fragment = template.content.cloneNode(true);
      const styles = [...fragment.querySelectorAll('link[rel="stylesheet"]')];
      const cssReady = Promise.all(styles.map(link => new Promise((resolve, reject) => {
        link.addEventListener('load', resolve, { once: true });
        link.addEventListener('error', reject, { once: true });
      })));
      template.after(fragment);
      let timer;
      try {
        await Promise.race([
          Promise.all([cssReady, import(template.dataset.searchScript)]),
          new Promise((_, reject) => { timer = setTimeout(() => reject(new Error('Search loading timed out')), 15000); }),
        ]);
      } finally {
        clearTimeout(timer);
      }
      const modal = document.getElementById('search-modal');
      if (typeof modal?.showDialog !== 'function' || !customElements.get('predictive-search-component')) {
        throw new Error('Native search unavailable');
      }
      document.removeEventListener('click', onClick, true);
      document.removeEventListener('keydown', onShortcut, true);
      if (wantsOpen) modal.showDialog();
      return modal;
    })().catch(() => {
      // Use Shopify's normal localized search page if either dependency fails.
      window.location.assign(template.dataset.searchUrl || '/search');
    });
    return loading;
  };

  function activate(event, toggle) {
    event.preventDefault();
    event.stopImmediatePropagation();
    wantsOpen = toggle ? !wantsOpen : true;
    load();
  }

  function onClick(event) {
    const target = event.target instanceof Element ? event.target.closest('[on\\:click]') : null;
    const action = target?.getAttribute('on:click');
    if (action === '#search-modal/showDialog' || action === '#search-modal/toggleDialog') {
      activate(event, action.endsWith('/toggleDialog'));
    }
  }

  function onShortcut(event) {
    // Match predictive-search.js exactly; Ctrl+k and uppercase K are unchanged.
    if (event.metaKey && event.key === 'k') activate(event, true);
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('keydown', onShortcut, true);
})();
